import { AliasesResponse } from 'types';
import { IAgent } from '../../types';

export interface IAgenciesState {
  list: IAgent[];
  currentAgency: IAgent;
  mappedAgentAliases?: AliasesResponse;
}

export enum AgencyActionTypes {
  GET_AGENCIES = '@@agency/GET_AGENCIES',
  GET_AGENCIES_SUCCESS = '@@agency/GET_AGENCIES_SUCCESS',
  GET_AGENCIES_FAILURE = '@@agency/GET_AGENCIES_FAILURE',
  GET_AGENT_ALIASES = '@@agency/GET_AGENT_ALIASES',
  GET_AGENT_ALIASES_SUCCESS = '@@agency/GET_AGENT_ALIASES_SUCCESS',
  GET_AGENT_ALIASES_FAILURE = '@@agency/GET_AGENT_ALIASES_FAILURE',
  GET_AGENCY_BY_ID = '@@agency/GET_AGENCY_BY_ID',
  GET_AGENCY_BY_ID_SUCCESS = '@@agency/GET_AGENCY_BY_ID_SUCCESS',
  GET_AGENCY_BY_ID_FAILURE = '@@agency/GET_AGENCY_BY_ID_FAILURE',
  SAVE_AGENCY = '@@agency/SAVE_AGENCY',
  SAVE_AGENCY_SUCCESS = '@@agency/SAVE_AGENCY_SUCCESS',
  SAVE_AGENCY_FAILURE = '@@agency/SAVE_AGENCY_FAILURE',
  DELETE_AGENCY = '@@agency/DELETE_AGENCY',
  DELETE_AGENCY_SUCCESS = '@@agency/DELETE_AGENCY_SUCCESS',
  DELETE_AGENCY_FAILURE = '@@agency/DELETE_AGENCY_FAILURE',
}
